module.exports = __webpack_public_path__ + "media/video-loop-lg.684b5407.mp4";